import { UserSubscriptionTransaction } from "@/domain/entities/UserSubscriptionTransaction"
import { ESubscriptionProvider, ESubsctiptionGrantType } from "@/domain/enums"
import { IapSubscriptionHistoryDTO, StripeSubscription, Transaction } from "../dto/SubscriptionHistoryResponseDTO"

const resolveStripeGrantType = (subscription: StripeSubscription): ESubsctiptionGrantType => {
    if (subscription.stripe_price === process.env.VUE_APP_BACKOFFICE_STRIPE_PRICE_ID) {
        return ESubsctiptionGrantType.ADMIN
    }
    if (subscription.plan_id) {
        return ESubsctiptionGrantType.PARTNERSHIP
    }
    return ESubsctiptionGrantType.PURCHASED
}

const transactionFromStripe = (subscription: StripeSubscription, transaction: Transaction): UserSubscriptionTransaction => {
    let status = subscription?.stripe_status
    if (subscription?.stripe_status == 'trialing') {
        if (subscription?.ends_at == subscription?.trial_ends_at) {
            status = 'cancelled_trialing'
        }
    } else if (subscription?.stripe_status == 'active') {
        if (subscription?.ends_at) {
            status = 'cancelled_active'
        }
    }
    return {
        subscription_provider: ESubscriptionProvider.STRIPE,
        subscription_grant_type: resolveStripeGrantType(subscription),
        status,
        subscription_date: transaction.payment_date,
        plan_title: subscription.plan?.title ?? 'Diag Pro',
        price: transaction.price,
        billing_cycle: subscription.plan?.billing_cycle ?? '',
    }
}

const transactionFromIap = (subscription: IapSubscriptionHistoryDTO, transaction: Transaction): UserSubscriptionTransaction => ({
    subscription_provider: ESubscriptionProvider.IAP,
    subscription_grant_type: ESubsctiptionGrantType.PURCHASED,
    status: transaction.status,
    subscription_date: transaction.payment_date,
    plan_title: subscription.plan.title,
    price: transaction.price,
    billing_cycle: subscription.plan.billing_cycle,
})

const toTransactionList = (data: { stripe_subscriptions: StripeSubscription[], iap_subscriptions: IapSubscriptionHistoryDTO[] }): UserSubscriptionTransaction[] => {
    const stripeTransactions = data.stripe_subscriptions.flatMap(sub =>
        sub.transactions.map(t => transactionFromStripe(sub, t))
    )

    const iapTransactions = data.iap_subscriptions.flatMap(sub =>
        sub.transactions.map(t => transactionFromIap(sub, t))
    )

    return [...stripeTransactions, ...iapTransactions]
        .sort((a, b) => new Date(b.subscription_date).getTime() - new Date(a.subscription_date).getTime())
}

export default { toTransactionList }
